import { mmI18nConstants } from "../i18n-constants";
import { TranslationGroup } from "../tanslation-group";
import { en } from "./en";
import { zh } from "./zh";


export const mmI18nTranslationGroup = {
    groupName: mmI18nConstants.translationGroup,
    translations: {
        "en": en,
        "zh": zh
    }
} as TranslationGroup;